import { render, staticRenderFns } from "./PublicTest.vue?vue&type=template&id=ec83c016"
import script from "./PublicTest.vue?vue&type=script&lang=js"
export * from "./PublicTest.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports